import { RecommendationPageType } from '../config';
import { GetRecommendationsByTypeQuery } from '../graphql/get-recommendations-by-type.gql-types';
import { RecommendationCardItem } from '../types/types';

type RecommendationNode = NonNullable<
  NonNullable<
    GetRecommendationsByTypeQuery['contentPagesNewsSourcesByType']
  >['edges'][number]
>['node'];

const getImageSourceByType = (node: RecommendationNode): string => {
  if (node.entityPage?.logoImage?.[0].url) {
    return node.entityPage.logoImage[0].url;
  }

  switch (node.__typename) {
    case 'ContentInsiderPage':
      return node.xingId?.profileImage?.[0]?.url ?? '';
    case 'ContentPage':
      return node.logoImage?.square128 ?? '';
    default:
      return '';
  }
};

const getCardUrl = (node: RecommendationNode): string => {
  const entityPageSlug = node.entityPage?.slug;
  if (entityPageSlug) {
    return `/pages/${entityPageSlug}`;
  }

  return node.url ?? '';
};

const getRecommendationCardItem = (
  node: RecommendationNode,
  type: RecommendationPageType
): RecommendationCardItem => {
  return {
    id: node.id,
    url: getCardUrl(node),
    imageSrc: getImageSourceByType(node),
    headline: node.title,
    description: node.description ?? '',
    isFollowed: !!node.interactions?.isFollowed,
    pageType: type,
    urn: node.globalId,
  };
};

export const getRecommendationCardItems = (
  type: RecommendationPageType,
  data: GetRecommendationsByTypeQuery | undefined
): RecommendationCardItem[] => {
  const edges = data?.contentPagesNewsSourcesByType?.edges;

  if (!edges?.length) return [];

  return edges
    .flatMap((edge) => (edge?.node ? [edge.node] : []))
    .map((node) => getRecommendationCardItem(node, type));
};
